import { Container, Col, Row, BreadcrumbItem } from "reactstrap";
import { useHistory } from "react-router-dom";
import * as Notify from "@repoflow/form-schema/notify";
import * as ViewsQL from "queries/view";
import { Component as Form } from "@repoflow/form-schema";
import { Mutation, Button, useSectionContext } from "@repoflow/components/section";
import * as appWidgets from "@shared/widgets/register";

export const Sidebar = () => null;
export const Indice = () => <BreadcrumbItem>New</BreadcrumbItem>;

// Name and title only. The query is written on the view's own screen, beside the
// Run button that says whether it works — which is the only place it can
// usefully be written.
export const Content = ({ match: { params } }) => {
  const history = useHistory();
  const { base } = useSectionContext();

  return (
    <Mutation
      initial={{ viewId: "", title: "", tags: [] }}
      target={{ $ref: "/Public/View/Create" }}
      mutation={ViewsQL.create}
      update={ViewsQL.update(params)}
      onMutate={({ state: { values }, handler }) => {
        handler({ variables: { input: values } });
      }}
      onCompleted={(data) => {
        // The FIRST argument is the data itself — Mutation calls
        // `onCompleted(data, sectionContext)`. Same trap as tables/new.
        const created = data?.viewer?.account?.views?.create;
        history.replace(created ? `${base}/${created.viewId}/` : base);
      }}
      onError={(error) => {
        const message = String(error);
        if (message.includes("view.create.reserved")) {
          const word = message.split("view.create.reserved:")[1] || "that word";
          Notify.error(`"${word}" is a SQL keyword — pick another name.`);
          return;
        }
        if (message.includes("view.create.invalid-id")) {
          Notify.error("A view name must start with a letter and use only lowercase letters, digits and underscores.");
          return;
        }
        if (message.includes("datum.create.exists")) {
          Notify.error("A view with that name already exists.");
          return;
        }
        Notify.error(message);
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

// The Mutation hands its children the section context — `schema`, `state`,
// `mutate`, `target` — and NOT a Fields component. The form is built from those.
const MutationHandler = ({ schema, state, mutate, target }) => {
  const { values, setValues } = state;

  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <Form
            schema={schema}
            target={target}
            values={values}
            widgets={appWidgets}
            onSubmit={() => mutate()}
            onChange={(vals) => setValues(vals)}
            config={{
              "/Public/View/Create": {
                fields: [{ property: "title" }, { property: "viewId" }, { property: "tags" }],
              },
            }}
          >
            <Button type="submit">Create</Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};
